<div *ngIf="length > 1" class="d-flex bullets">
    <div *ngFor="let bullet of bullets; let i = index" class="bullet" [ngClass]="{ 'active': index == i }"></div>
</div>